var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDishes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.188,
    viewBox: "0 0 28.89 19.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;;fill:#cea95a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.44,0C9.12,0,4.81,4.32,4.81,9.63c0,5.32,4.32,9.63,9.63,9.63,5.32,0,9.63-4.31,9.63-9.63C24.07,4.31,19.76,0,14.44,0h0Zm0,18.06c-4.65,0-8.43-3.77-8.43-8.43S9.79,1.2,14.44,1.2s8.43,3.77,8.43,8.43c0,4.65-3.77,8.42-8.43,8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.05,3.01c0-.33-.27-.6-.6-.6-3.99,0-7.22,3.23-7.23,7.22,0,.33.27.6.6.6.33,0,.6-.27.6-.6,0-3.32,2.69-6.02,6.02-6.02.33,0,.6-.27.61-.6,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.44,15.65c-.33,0-.6.27-.6.6s.27.6.6.6h0c3.99,0,7.22-3.24,7.22-7.22,0-.33-.27-.6-.6-.6-.33,0-.6.27-.6.6,0,3.32-2.69,6.02-6.02,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.28,0c-1.66,0-3.01,1.35-3.01,3.01h0v6.62c0,1,.81,1.81,1.81,1.81h.6v7.22c0,.33.27.6.6.6.33,0,.6-.27.6-.6V.6C28.89.27,28.62,0,28.29,0h0Zm-.6,10.23h-.6c-.33,0-.6-.27-.6-.6V3.01c0-.77.48-1.45,1.2-1.7v8.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.81.6C4.81.27,4.54,0,4.21,0s-.6.27-.6.6h0v5.42c0,.42-.23.81-.6,1.02V.6C3.01.27,2.74,0,2.41,0s-.6.27-.6.6h0v6.44c-.37-.21-.6-.6-.6-1.02V.6C1.2.27.93,0,.6,0,.27,0,0,.27,0,.6c0,0,0,0,0,0v5.42c0,1.09.75,2.05,1.81,2.32v10.32c0,.33.27.6.6.6s.6-.27.6-.6v-10.32c1.06-.27,1.8-1.23,1.81-2.32V.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishes);
export default __webpack_public_path__ + "static/media/dishes.7a0138a41b5b7652d1431f03113b844e.svg";
export { ForwardRef as ReactComponent };